export interface IReportsTitleBarState {
  companies: any[];
  isLoading: boolean;
  error: string;
  isError: boolean;
}

export const state: IReportsTitleBarState = {
  companies: [],
  isLoading: true,
  error: "",
  isError: false,
};

export default state;
